import { useState } from "react";
import { useParams } from "react-router-dom";
import { useAppState } from "../../context/AppStateContext";
import { ComingSoonTabPanel } from "../ComingSoonTabPanel";
import { areMilestonesAndBillsUnavailable } from "../milestoneBillsGate";

export function BillsTab() {
  const { id } = useParams<{ id: string }>();
  const { getById, addWorkDoneBill, confirmBillSeeding } = useAppState();
  const app = id ? getById(id) : undefined;
  const [billDraft, setBillDraft] = useState("");

  if (!app) return null;

  if (areMilestonesAndBillsUnavailable(app)) {
    return (
      <ComingSoonTabPanel
        title="Bills — coming soon"
        appId={app.id}
        body="Work-done bills and seeding confirmation are not available in this console yet — before or after subcontractor linkage. Your office will enable this step when the workflow is ready."
      />
    );
  }

  return (
    <>
      <p className="tab-intro">
        <strong>Simple flow:</strong> (1) Attach a bill file as a reference. (2) For each row, the <strong>site officer</strong>{" "}
        must press confirm when seeding has been checked again. Nothing else is needed from HO for that row after confirm.
      </p>

      <div className="card card--gov card--elevated">
        <h2 className="card__title card__title--gov">Register work-done bill</h2>
        <div className="toolbar-row" style={{ alignItems: "flex-end" }}>
          <div className="field field-inline">
            <label>Upload bill (reference)</label>
            <input type="file" accept=".pdf,image/*" onChange={(e) => setBillDraft(e.target.files?.[0]?.name ?? "")} />
          </div>
          <button
            type="button"
            className="btn btn--tg-secondary"
            disabled={!billDraft}
            onClick={() => {
              void (async () => {
                try {
                  await addWorkDoneBill(app.id, billDraft);
                  setBillDraft("");
                } catch {
                  /* addWorkDoneBill shows error toast */
                }
              })();
            }}
          >
            Add to dossier
          </button>
        </div>
      </div>

      <div className="card card--gov card--elevated">
        <h2 className="card__title card__title--gov">Bills on file</h2>
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>File reference</th>
                <th>Uploaded</th>
                <th>Seeding re-verified</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {app.workDoneBills.length === 0 ? (
                <tr>
                  <td colSpan={4} className="empty-cell">
                    No bills registered for this beneficiary.
                  </td>
                </tr>
              ) : (
                app.workDoneBills.map((b) => (
                  <tr key={b.id}>
                    <td className="mono">{b.fileName}</td>
                    <td className="mono">{b.uploadedAt.slice(0, 16).replace("T", " ")}</td>
                    <td>
                      {b.seedingReVerified ? (
                        <span className="badge badge--ok">Yes</span>
                      ) : (
                        <span className="badge badge--pending">Pending</span>
                      )}
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn btn--primary btn--tg btn--sm"
                        disabled={b.seedingReVerified}
                        onClick={() => void confirmBillSeeding(app.id, b.id)}
                      >
                        Site officer confirms re-verify
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
